import { RoutePaths } from '@interfaces/routePaths'
import { SettingsLayout } from '../SettingsLayout'
import { Base } from '@views/AdminSettings/Base'
import { Account } from '@views/AdminSettings/Account'
import { AccountOrganization } from '@views/AdminSettings/AccountOrganization'
import { AccountRepresentatives } from '@views/AdminSettings/AccountRepresentatives'
import { Location } from '@views/AdminSettings/Location'
import { LocationPublicProfile } from '@views/AdminSettings/LocationPublicProfile'
import { LocationAutoTagging } from '@views/AdminSettings/LocationAutoTagging'
import { LocationHighlightedTags } from '@views/AdminSettings/LocationHighlightedTags'
import { LocationCustomFields } from '@views/AdminSettings/LocationCustomFields'
import { LocationList } from '@views/AdminSettings/LocationList'
import { Staff } from '@views/AdminSettings/Staff'
import { Records } from '@views/AdminSettings/Records'
import { PermissionSetsList } from '@views/AdminSettings/PermissionSetsList'
import { PermissionSets } from '@views/AdminSettings/PermissionSets'
import { PermissionSetsDetails } from '@views/AdminSettings/PermissionSetsDetails'
import { PermissionSetsCustomFields } from '@views/AdminSettings/PermissionSetsCustomFields'
import { PermissionSetsStaff } from '@views/AdminSettings/PermissionSetsStaff'
import { ExclusiveTags } from '@views/AdminSettings/ExclusiveTags'
import { Stages } from '@views/AdminSettings/Stages'
import { CallsDispositions } from '@views/AdminSettings/CallsDispositions'
import { CallsPurposes } from '@views/AdminSettings/CallsPurposes'
import { Calls } from '@views/AdminSettings/Calls'
import { Incidents } from '@views/AdminSettings/Incidents'
import { IncidentsSource } from '@views/AdminSettings/IncidentsSource'
import { IncidentsActionTaken } from '@views/AdminSettings/IncidentsActionTaken'
import { FileCategories } from '@views/AdminSettings/FileCategories'
import { CustomFields } from '@views/AdminSettings/CustomFields'
import { CustomFieldsControl } from '@views/AdminSettings/CustomFieldsControl'
import { CustomFieldsControlDataType } from '@views/AdminSettings/CustomFieldsControlDataType'
import { CustomFieldsControlFieldDetails } from '@views/AdminSettings/CustomFieldsControlFieldDetails'
import { CustomFieldsControlRecordVisibility } from '@views/AdminSettings/CustomFieldsControlRecordVisibility'
import { CustomFieldsControlFieldLevelSecurity } from '@views/AdminSettings/CustomFieldsControlFieldLevelSecurity'
import { CallsDispositionsAdd } from '@views/AdminSettings/CallsDispotionsAdd'

export const ADMIN_SETTINGS = [
  {
    path: RoutePaths.ADMIN_SETTINGS,
    element: <SettingsLayout type="admin" />,
    children: [
      {
        path: RoutePaths.ADMIN_SETTINGS_ACCOUNT,
        element: (
          <Base>
            <Account />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_ACCOUNT_ORGANIZATION,
            element: <AccountOrganization />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_ACCOUNT_REPRESENTATIVES,
            element: <AccountRepresentatives />,
          },
        ],
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_LOCATION_LIST,
        element: (
          <Base>
            <LocationList />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_LOCATION,
        element: (
          <Base>
            <Location />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_LOCATION_PUBLIC_PROFILE,
            element: <LocationPublicProfile />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_LOCATION_AUTO_TAGGING,
            element: <LocationAutoTagging />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_LOCATION_HIGHLIGHTED_TAGS,
            element: <LocationHighlightedTags />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_LOCATION_CUSTOM_FIELDS,
            element: <LocationCustomFields />,
          },
        ],
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_STAFF,
        element: (
          <Base>
            <Staff />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_RECORDS,
        element: (
          <Base>
            <Records />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_LIST,
        element: (
          <Base>
            <PermissionSetsList />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS,
        element: (
          <Base>
            <PermissionSets />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_DETAILS,
            element: <PermissionSetsDetails />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_CUSTOM_FIELD_VISIBILITY,
            element: <PermissionSetsCustomFields />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_STAFF,
            element: <PermissionSetsStaff />,
          },
        ],
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_EXCLUSIVE_TAGS,
        element: (
          <Base>
            <ExclusiveTags />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_STAGES,
        element: (
          <Base>
            <Stages />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_CALLS,
        element: (
          <Base>
            <Calls />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_CALLS_DISPOSITIONS,
            element: <CallsDispositions />,
            children: [
              {
                path: RoutePaths.ADMIN_SETTINGS_CALLS_DISPOSITIONS_ADD,
                element: <CallsDispositionsAdd />,
              },
            ],
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_CALLS_PURPOSES,
            element: <CallsPurposes />,
          },
        ],
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_INCIDENTS,
        element: (
          <Base>
            <Incidents />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_INCIDENTS_SOURCE,
            element: <IncidentsSource />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_INCIDENTS_ACTION_TAKEN,
            element: <IncidentsActionTaken />,
          },
        ],
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_FILE_CATEGORIES,
        element: (
          <Base>
            <FileCategories />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS,
        element: (
          <Base>
            <CustomFields />
          </Base>
        ),
      },
      {
        path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL,
        element: (
          <Base>
            <CustomFieldsControl />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_DATA_TYPE,
            element: <CustomFieldsControlDataType />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_DETAILS,
            element: <CustomFieldsControlFieldDetails />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_RECORD_VISIBILITY,
            element: <CustomFieldsControlRecordVisibility />,
          },
          {
            path: RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_LEVEL_SECURITY,
            element: <CustomFieldsControlFieldLevelSecurity />,
          },
        ],
      },
    ],
  },
]
